import PropTypes from 'prop-types';

export const BULK_ACTION_COMMON = {
  isOpen: PropTypes.bool.isRequired,
  showAlert: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export const BULK_ACTION_ENDDATE = {
  isOpen: PropTypes.bool.isRequired,
  showAlert: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export const BULK_ACTION_CONSULT = {
  isOpen: PropTypes.bool.isRequired,
  showAlert: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export const BULK_ACTION_REASSIGN = {
  isOpen: PropTypes.bool.isRequired,
  showAlert: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};
